import type { Config } from 'tailwindcss';

export default {
  content: ['src/**/*.{js,jsx,ts,tsx}'],
  prefix: 'pnk-',
  theme: {
    extend: {
      //  display: ['group-hover'],
      colors: {
        black: '#333333',
        white: '#FFFFFF',
        error: '#E82E2C',
        primary: {
          base: '#E82C88',
          hover: '#C7166D',
        },
        secondary: {
          base: '#FAD5E7',
          hover: '#C7166D',
        },
        accent: '#6DC716',
        surface: '#F5F5F5',
        disabled: {
          base: '#E3E3E3',
          text: '#777777',
        },
      },
      fontSize: {
        base: '15px',
        small: '13px',
      },

      fontFamily: {
        icon: ['PancakeIcons', 'sans-serif'],
        base: ['Roboto', 'sans-serif'],
      },
      borderRadius: {
        def: '5px',
      },
    },
  },
  plugins: [],
} as Config;
